export default [
  {
    path: '/desempenho/menu',
    name: 'Desempenho Acadêmico',
    meta: { layout: 'default' },
    component: () => import('@/views/tec-ped/desempenhoAcademico/menu.vue'),
  },
  {
    path: '/desempenho/lista-de-escolas',
    name: 'Lista de Escolas e Status',
    meta: { layout: 'default' },
    component: () => import('@/views/tec-ped/desempenhoAcademico/lista-de-escolas.vue'),
  },
  {
    path: '/desempenho/media-por-escola',
    name: 'Desempenho Acadêmico',
    meta: { layout: 'default' },
    component: () => import('@/views/tec-ped/desempenhoAcademico/media-notas-por-escola.vue'),
  },
  {
    path: '/desempenho/taxa-aprovacao-reprovacao',
    name: 'Taxa de Aprovação e Reprovação por Ano Letivo',
    meta: { layout: 'default' },
    component: () => import('@/views/tec-ped/desempenhoAcademico/taxa_de_aprovacao_reprovacao.vue'),
  },
  {
    path: '/desempenho/media-por-trimestre',
    name: 'Evolução da Média por Trimestre',
    meta: { layout: 'default' },
    component: () => import('@/views/tec-ped/desempenhoAcademico/media_por_trimestre.vue'),
  },
  {
    path: '/desempenho/media-por-disciplina',
    name: 'Média de notas por disciplina',
    meta: { layout: 'default' },
    component: () => import('@/views/tec-ped/desempenhoAcademico/media_nota_por_disciplina.vue'),
  },
  {
    path: '/desempenho/desempenho-por-genero',
    name: 'Desempenho acadêmico por gênero',
    meta: { layout: 'default' },
    component: () => import('@/views/tec-ped/desempenhoAcademico/desempenho_por_genero.vue'),
  },
  {
    path: '/desempenho/notas-por-faixa',
    name: 'Distribuição de Notas por Faixa de Desempenho',
    meta: { layout: 'default' },
    component: () => import('@/views/tec-ped/desempenhoAcademico/distribuicao_de_nota_faixa.vue'),
  },
];
